// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file context/context.proto (package lvdr.v2.context, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file context/context.proto.
 */
export const file_context_context: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Every field is optional: an update changes only the fields present, and a present empty
 * string clears the field (protobuf empty strings must not erase fields — review checklist).
 *
 * @generated from message lvdr.v2.context.NodeProperties
 */
export type NodeProperties = Message<"lvdr.v2.context.NodeProperties"> & {
  /**
   * "any", "sovereign", "confidential"; "" clears; anything else is refused
   *
   * @generated from field: optional string trust_floor = 1;
   */
  trustFloor?: string | undefined;

  /**
   * nearest set value wins
   *
   * @generated from field: optional string tone = 2;
   */
  tone?: string | undefined;

  /**
   * @generated from field: optional string language = 3;
   */
  language?: string | undefined;

  /**
   * @generated from field: optional string citation_style = 4;
   */
  citationStyle?: string | undefined;

  /**
   * @generated from field: optional string how_i_work = 5;
   */
  howIWork?: string | undefined;
};

/**
 * Describes the message lvdr.v2.context.NodeProperties.
 * Use `create(NodePropertiesSchema)` to create a new message.
 */
export const NodePropertiesSchema: GenMessage<NodeProperties> = /*@__PURE__*/
  messageDesc(file_context_context, 0);

/**
 * @generated from message lvdr.v2.context.ContextNode
 */
export type ContextNode = Message<"lvdr.v2.context.ContextNode"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * sorted; mirrors ctx:er: rows
   *
   * @generated from field: repeated string parents = 3;
   */
  parents: string[];

  /**
   * @generated from field: lvdr.v2.context.NodeProperties properties = 4;
   */
  properties?: NodeProperties | undefined;

  /**
   * @generated from field: bool archived = 5;
   */
  archived: boolean;

  /**
   * @generated from field: int64 created_at_ms = 6;
   */
  createdAtMs: bigint;

  /**
   * MEM-12: set by merge_nodes: the node this one was merged into (it is archived)
   *
   * @generated from field: string merged_into = 7;
   */
  mergedInto: string;

  /**
   * MEM-12: set by node_to_entity: the kn: entity id it became (it is archived)
   *
   * @generated from field: string became_entity = 8;
   */
  becameEntity: string;
};

/**
 * Describes the message lvdr.v2.context.ContextNode.
 * Use `create(ContextNodeSchema)` to create a new message.
 */
export const ContextNodeSchema: GenMessage<ContextNode> = /*@__PURE__*/
  messageDesc(file_context_context, 1);

/**
 * @generated from message lvdr.v2.context.ContextEdge
 */
export type ContextEdge = Message<"lvdr.v2.context.ContextEdge"> & {
  /**
   * @generated from field: string parent_id = 1;
   */
  parentId: string;

  /**
   * @generated from field: string child_id = 2;
   */
  childId: string;
};

/**
 * Describes the message lvdr.v2.context.ContextEdge.
 * Use `create(ContextEdgeSchema)` to create a new message.
 */
export const ContextEdgeSchema: GenMessage<ContextEdge> = /*@__PURE__*/
  messageDesc(file_context_context, 2);

/**
 * @generated from message lvdr.v2.context.LinkSet
 */
export type LinkSet = Message<"lvdr.v2.context.LinkSet"> & {
  /**
   * @generated from field: repeated string node_ids = 1;
   */
  nodeIds: string[];
};

/**
 * Describes the message lvdr.v2.context.LinkSet.
 * Use `create(LinkSetSchema)` to create a new message.
 */
export const LinkSetSchema: GenMessage<LinkSet> = /*@__PURE__*/
  messageDesc(file_context_context, 3);

/**
 * @generated from message lvdr.v2.context.HistoryRow
 */
export type HistoryRow = Message<"lvdr.v2.context.HistoryRow"> & {
  /**
   * @generated from field: bytes key = 1;
   */
  key: Uint8Array;

  /**
   * @generated from field: bytes before = 2;
   */
  before: Uint8Array;

  /**
   * @generated from field: bool before_absent = 3;
   */
  beforeAbsent: boolean;

  /**
   * @generated from field: bytes after = 4;
   */
  after: Uint8Array;

  /**
   * @generated from field: bool after_absent = 5;
   */
  afterAbsent: boolean;
};

/**
 * Describes the message lvdr.v2.context.HistoryRow.
 * Use `create(HistoryRowSchema)` to create a new message.
 */
export const HistoryRowSchema: GenMessage<HistoryRow> = /*@__PURE__*/
  messageDesc(file_context_context, 4);

/**
 * @generated from message lvdr.v2.context.HistoryEntry
 */
export type HistoryEntry = Message<"lvdr.v2.context.HistoryEntry"> & {
  /**
   * @generated from field: uint64 seq = 1;
   */
  seq: bigint;

  /**
   * @generated from field: string batch_id = 2;
   */
  batchId: string;

  /**
   * "root.create", "node.create", "node.update", "node.parents", "node.archive", "links.set", "lastused.set", "classification.set", "proposal.apply", "undo", "undo.kind_owned", "node.erase"
   *
   * @generated from field: string op = 3;
   */
  op: string;

  /**
   * @generated from field: int64 at_ms = 4;
   */
  atMs: bigint;

  /**
   * "user" (personal WS), "user:<id>" (a member's WS write on a ws: graph, MEM-12b D21), "chat:<session>", "mcp:<token>", "proposal:<id>", "undo:<seq>"
   *
   * @generated from field: string actor = 5;
   */
  actor: string;

  /**
   * @generated from field: repeated lvdr.v2.context.HistoryRow rows = 6;
   */
  rows: HistoryRow[];

  /**
   * set ⇒ kind-owned inverse in undo_payload
   *
   * @generated from field: string undo_kind = 7;
   */
  undoKind: string;

  /**
   * @generated from field: bytes undo_payload = 8;
   */
  undoPayload: Uint8Array;

  /**
   * @generated from field: bool undone = 9;
   */
  undone: boolean;

  /**
   * MEM-12: an erase removed the row images or payload this entry held; undo refuses it
   *
   * @generated from field: bool redacted = 10;
   */
  redacted: boolean;

  /**
   * MEM-12b (D16): one line for people, computed on read by Graph.fillSummaries; never stored
   *
   * @generated from field: string summary = 11;
   */
  summary: string;

  /**
   * MEM-09n (D21): a member's display name on a ws: graph, computed on read; "" = not known
   *
   * @generated from field: string actor_name = 12;
   */
  actorName: string;
};

/**
 * Describes the message lvdr.v2.context.HistoryEntry.
 * Use `create(HistoryEntrySchema)` to create a new message.
 */
export const HistoryEntrySchema: GenMessage<HistoryEntry> = /*@__PURE__*/
  messageDesc(file_context_context, 5);

/**
 * @generated from message lvdr.v2.context.Proposal
 */
export type Proposal = Message<"lvdr.v2.context.Proposal"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * the kind's own message, proto-encoded (never JSON)
   *
   * @generated from field: bytes payload = 3;
   */
  payload: Uint8Array;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * "pending", "applied", "dismissed"
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: int64 created_at_ms = 6;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: int64 decided_at_ms = 7;
   */
  decidedAtMs: bigint;

  /**
   * filled on read from the kind's Preview
   *
   * @generated from field: string preview = 9;
   */
  preview: string;

  /**
   * MEM-12: an erase removed the payload; preview reads "erased"
   *
   * @generated from field: bool redacted = 10;
   */
  redacted: boolean;

  /**
   * MEM-10: why this was proposed; "" for others; <= 512 bytes; cleared by an erase
   *
   * @generated from field: string reason = 11;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.context.Proposal.
 * Use `create(ProposalSchema)` to create a new message.
 */
export const ProposalSchema: GenMessage<Proposal> = /*@__PURE__*/
  messageDesc(file_context_context, 6);

/**
 * Built-in proposal payloads.
 * create_node: parent_ids may name real node IDs or the temp_id of an earlier create_node in the
 * same batch (packet D115, the setup assistant's one-batch apply).
 *
 * @generated from message lvdr.v2.context.CreateNodeProposal
 */
export type CreateNodeProposal = Message<"lvdr.v2.context.CreateNodeProposal"> & {
  /**
   * @generated from field: string temp_id = 1;
   */
  tempId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated string parent_ids = 3;
   */
  parentIds: string[];

  /**
   * @generated from field: lvdr.v2.context.NodeProperties properties = 4;
   */
  properties?: NodeProperties | undefined;
};

/**
 * Describes the message lvdr.v2.context.CreateNodeProposal.
 * Use `create(CreateNodeProposalSchema)` to create a new message.
 */
export const CreateNodeProposalSchema: GenMessage<CreateNodeProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 7);

/**
 * @generated from message lvdr.v2.context.LinkProposal
 */
export type LinkProposal = Message<"lvdr.v2.context.LinkProposal"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: string node_id = 3;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.context.LinkProposal.
 * Use `create(LinkProposalSchema)` to create a new message.
 */
export const LinkProposalSchema: GenMessage<LinkProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 8);

/**
 * @generated from message lvdr.v2.context.UnlinkProposal
 */
export type UnlinkProposal = Message<"lvdr.v2.context.UnlinkProposal"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: string node_id = 3;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.context.UnlinkProposal.
 * Use `create(UnlinkProposalSchema)` to create a new message.
 */
export const UnlinkProposalSchema: GenMessage<UnlinkProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 9);

/**
 * @generated from message lvdr.v2.context.MoveUpProposal
 */
export type MoveUpProposal = Message<"lvdr.v2.context.MoveUpProposal"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: string from_node_id = 3;
   */
  fromNodeId: string;
};

/**
 * Describes the message lvdr.v2.context.MoveUpProposal.
 * Use `create(MoveUpProposalSchema)` to create a new message.
 */
export const MoveUpProposalSchema: GenMessage<MoveUpProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 10);

/**
 * @generated from message lvdr.v2.context.MarkPublicProposal
 */
export type MarkPublicProposal = Message<"lvdr.v2.context.MarkPublicProposal"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;
};

/**
 * Describes the message lvdr.v2.context.MarkPublicProposal.
 * Use `create(MarkPublicProposalSchema)` to create a new message.
 */
export const MarkPublicProposalSchema: GenMessage<MarkPublicProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 11);

/**
 * @generated from message lvdr.v2.context.ArchiveNodeProposal
 */
export type ArchiveNodeProposal = Message<"lvdr.v2.context.ArchiveNodeProposal"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.context.ArchiveNodeProposal.
 * Use `create(ArchiveNodeProposalSchema)` to create a new message.
 */
export const ArchiveNodeProposalSchema: GenMessage<ArchiveNodeProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 12);

/**
 * Registered in MEM-09a, applied by MEM-09c (packet D52, D55).
 *
 * @generated from message lvdr.v2.context.AcceptFactProposal
 */
export type AcceptFactProposal = Message<"lvdr.v2.context.AcceptFactProposal"> & {
  /**
   * @generated from field: string fact_id = 1;
   */
  factId: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: string node_id = 3;
   */
  nodeId: string;

  /**
   * @generated from field: string source_kind = 4;
   */
  sourceKind: string;

  /**
   * @generated from field: string source_id = 5;
   */
  sourceId: string;

  /**
   * @generated from field: string entity_name = 6;
   */
  entityName: string;
};

/**
 * Describes the message lvdr.v2.context.AcceptFactProposal.
 * Use `create(AcceptFactProposalSchema)` to create a new message.
 */
export const AcceptFactProposalSchema: GenMessage<AcceptFactProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 13);

/**
 * MEM-09c: text is the new statement (required for resolution "keep_new"); old_text is the
 * conflicting fact's text so a preview renders both from the payload alone.
 *
 * @generated from message lvdr.v2.context.ResolveContradictionProposal
 */
export type ResolveContradictionProposal = Message<"lvdr.v2.context.ResolveContradictionProposal"> & {
  /**
   * @generated from field: string fact_id = 1;
   */
  factId: string;

  /**
   * @generated from field: string conflicting_fact_id = 2;
   */
  conflictingFactId: string;

  /**
   * @generated from field: string resolution = 3;
   */
  resolution: string;

  /**
   * @generated from field: string text = 4;
   */
  text: string;

  /**
   * @generated from field: string old_text = 5;
   */
  oldText: string;
};

/**
 * Describes the message lvdr.v2.context.ResolveContradictionProposal.
 * Use `create(ResolveContradictionProposalSchema)` to create a new message.
 */
export const ResolveContradictionProposalSchema: GenMessage<ResolveContradictionProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 14);

/**
 * MEM-09d: convert a library scope into one node and file its own-tag items in it.
 *
 * @generated from message lvdr.v2.context.ScopeToContextProposal
 */
export type ScopeToContextProposal = Message<"lvdr.v2.context.ScopeToContextProposal"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string parent_node_id = 3;
   */
  parentNodeId: string;

  /**
   * @generated from field: repeated lvdr.v2.context.ContextItemRef items = 4;
   */
  items: ContextItemRef[];

  /**
   * @generated from field: optional string trust_floor = 5;
   */
  trustFloor?: string | undefined;
};

/**
 * Describes the message lvdr.v2.context.ScopeToContextProposal.
 * Use `create(ScopeToContextProposalSchema)` to create a new message.
 */
export const ScopeToContextProposalSchema: GenMessage<ScopeToContextProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 15);

/**
 * The session pointer's message (MEM-09c writes it; packet D70).
 *
 * @generated from message lvdr.v2.context.ContextPointer
 */
export type ContextPointer = Message<"lvdr.v2.context.ContextPointer"> & {
  /**
   * @generated from field: string graph = 1;
   */
  graph: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.context.ContextPointer.
 * Use `create(ContextPointerSchema)` to create a new message.
 */
export const ContextPointerSchema: GenMessage<ContextPointer> = /*@__PURE__*/
  messageDesc(file_context_context, 16);

/**
 * @generated from message lvdr.v2.context.ContextGraph
 */
export type ContextGraph = Message<"lvdr.v2.context.ContextGraph"> & {
  /**
   * @generated from field: repeated lvdr.v2.context.ContextNode nodes = 1;
   */
  nodes: ContextNode[];

  /**
   * @generated from field: repeated lvdr.v2.context.ContextEdge edges = 2;
   */
  edges: ContextEdge[];

  /**
   * @generated from field: uint64 version = 3;
   */
  version: bigint;

  /**
   * @generated from field: string root_id = 4;
   */
  rootId: string;
};

/**
 * Describes the message lvdr.v2.context.ContextGraph.
 * Use `create(ContextGraphSchema)` to create a new message.
 */
export const ContextGraphSchema: GenMessage<ContextGraph> = /*@__PURE__*/
  messageDesc(file_context_context, 17);

/**
 * --- requests / responses ---
 *
 * @generated from message lvdr.v2.context.ContextGraphGetRequest
 */
export type ContextGraphGetRequest = Message<"lvdr.v2.context.ContextGraphGetRequest"> & {
  /**
   * @generated from field: string graph = 1;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextGraphGetRequest.
 * Use `create(ContextGraphGetRequestSchema)` to create a new message.
 */
export const ContextGraphGetRequestSchema: GenMessage<ContextGraphGetRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 18);

/**
 * @generated from message lvdr.v2.context.ContextGraphResponse
 */
export type ContextGraphResponse = Message<"lvdr.v2.context.ContextGraphResponse"> & {
  /**
   * @generated from field: lvdr.v2.context.ContextGraph graph = 1;
   */
  graph?: ContextGraph | undefined;

  /**
   * @generated from field: string graph_key = 2;
   */
  graphKey: string;
};

/**
 * Describes the message lvdr.v2.context.ContextGraphResponse.
 * Use `create(ContextGraphResponseSchema)` to create a new message.
 */
export const ContextGraphResponseSchema: GenMessage<ContextGraphResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 19);

/**
 * @generated from message lvdr.v2.context.ContextNodeCreateRequest
 */
export type ContextNodeCreateRequest = Message<"lvdr.v2.context.ContextNodeCreateRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: repeated string parent_ids = 2;
   */
  parentIds: string[];

  /**
   * @generated from field: lvdr.v2.context.NodeProperties properties = 3;
   */
  properties?: NodeProperties | undefined;

  /**
   * @generated from field: string graph = 4;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextNodeCreateRequest.
 * Use `create(ContextNodeCreateRequestSchema)` to create a new message.
 */
export const ContextNodeCreateRequestSchema: GenMessage<ContextNodeCreateRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 20);

/**
 * @generated from message lvdr.v2.context.ContextNodeUpdateRequest
 */
export type ContextNodeUpdateRequest = Message<"lvdr.v2.context.ContextNodeUpdateRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: lvdr.v2.context.NodeProperties properties = 3;
   */
  properties?: NodeProperties | undefined;

  /**
   * @generated from field: bool confirm_raise = 4;
   */
  confirmRaise: boolean;

  /**
   * @generated from field: string graph = 5;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextNodeUpdateRequest.
 * Use `create(ContextNodeUpdateRequestSchema)` to create a new message.
 */
export const ContextNodeUpdateRequestSchema: GenMessage<ContextNodeUpdateRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 21);

/**
 * @generated from message lvdr.v2.context.ContextNodeSetParentsRequest
 */
export type ContextNodeSetParentsRequest = Message<"lvdr.v2.context.ContextNodeSetParentsRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: repeated string parent_ids = 2;
   */
  parentIds: string[];

  /**
   * @generated from field: bool confirm_raise = 3;
   */
  confirmRaise: boolean;

  /**
   * @generated from field: string graph = 4;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextNodeSetParentsRequest.
 * Use `create(ContextNodeSetParentsRequestSchema)` to create a new message.
 */
export const ContextNodeSetParentsRequestSchema: GenMessage<ContextNodeSetParentsRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 22);

/**
 * @generated from message lvdr.v2.context.ContextNodeArchiveRequest
 */
export type ContextNodeArchiveRequest = Message<"lvdr.v2.context.ContextNodeArchiveRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: bool archived = 2;
   */
  archived: boolean;

  /**
   * @generated from field: string graph = 3;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextNodeArchiveRequest.
 * Use `create(ContextNodeArchiveRequestSchema)` to create a new message.
 */
export const ContextNodeArchiveRequestSchema: GenMessage<ContextNodeArchiveRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 23);

/**
 * MEM-09e — what a trust-floor raise affects; returned unwritten until the
 * client re-sends with confirm_raise.
 *
 * @generated from message lvdr.v2.context.ContextRaisePreview
 */
export type ContextRaisePreview = Message<"lvdr.v2.context.ContextRaisePreview"> & {
  /**
   * @generated from field: int32 nodes = 1;
   */
  nodes: number;

  /**
   * @generated from field: int32 items = 2;
   */
  items: number;

  /**
   * @generated from field: int32 processed_standard = 3;
   */
  processedStandard: number;

  /**
   * @generated from field: int32 processed_unknown = 4;
   */
  processedUnknown: number;

  /**
   * @generated from field: string to_floor = 5;
   */
  toFloor: string;
};

/**
 * Describes the message lvdr.v2.context.ContextRaisePreview.
 * Use `create(ContextRaisePreviewSchema)` to create a new message.
 */
export const ContextRaisePreviewSchema: GenMessage<ContextRaisePreview> = /*@__PURE__*/
  messageDesc(file_context_context, 24);

/**
 * @generated from message lvdr.v2.context.ContextNodeResponse
 */
export type ContextNodeResponse = Message<"lvdr.v2.context.ContextNodeResponse"> & {
  /**
   * @generated from field: lvdr.v2.context.ContextNode node = 1;
   */
  node?: ContextNode | undefined;

  /**
   * @generated from field: uint64 history_seq = 2;
   */
  historySeq: bigint;

  /**
   * @generated from field: lvdr.v2.context.ContextRaisePreview raise_preview = 3;
   */
  raisePreview?: ContextRaisePreview | undefined;
};

/**
 * Describes the message lvdr.v2.context.ContextNodeResponse.
 * Use `create(ContextNodeResponseSchema)` to create a new message.
 */
export const ContextNodeResponseSchema: GenMessage<ContextNodeResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 25);

/**
 * @generated from message lvdr.v2.context.ContextLinksGetRequest
 */
export type ContextLinksGetRequest = Message<"lvdr.v2.context.ContextLinksGetRequest"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: string graph = 3;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextLinksGetRequest.
 * Use `create(ContextLinksGetRequestSchema)` to create a new message.
 */
export const ContextLinksGetRequestSchema: GenMessage<ContextLinksGetRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 26);

/**
 * @generated from message lvdr.v2.context.ContextLinksSetRequest
 */
export type ContextLinksSetRequest = Message<"lvdr.v2.context.ContextLinksSetRequest"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: repeated string node_ids = 3;
   */
  nodeIds: string[];

  /**
   * @generated from field: string graph = 4;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextLinksSetRequest.
 * Use `create(ContextLinksSetRequestSchema)` to create a new message.
 */
export const ContextLinksSetRequestSchema: GenMessage<ContextLinksSetRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 27);

/**
 * @generated from message lvdr.v2.context.ContextLinksResponse
 */
export type ContextLinksResponse = Message<"lvdr.v2.context.ContextLinksResponse"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: repeated string node_ids = 3;
   */
  nodeIds: string[];

  /**
   * @generated from field: uint64 history_seq = 4;
   */
  historySeq: bigint;
};

/**
 * Describes the message lvdr.v2.context.ContextLinksResponse.
 * Use `create(ContextLinksResponseSchema)` to create a new message.
 */
export const ContextLinksResponseSchema: GenMessage<ContextLinksResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 28);

/**
 * @generated from message lvdr.v2.context.ContextItemsOnNodeRequest
 */
export type ContextItemsOnNodeRequest = Message<"lvdr.v2.context.ContextItemsOnNodeRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string graph = 2;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextItemsOnNodeRequest.
 * Use `create(ContextItemsOnNodeRequestSchema)` to create a new message.
 */
export const ContextItemsOnNodeRequestSchema: GenMessage<ContextItemsOnNodeRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 29);

/**
 * @generated from message lvdr.v2.context.ContextItemRef
 */
export type ContextItemRef = Message<"lvdr.v2.context.ContextItemRef"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * MEM-12b: filled on ContextItemsOnNodeResponse (personal graph) from the item's source; "" = not known. Ignored on requests.
   *
   * @generated from field: string title = 3;
   */
  title: string;
};

/**
 * Describes the message lvdr.v2.context.ContextItemRef.
 * Use `create(ContextItemRefSchema)` to create a new message.
 */
export const ContextItemRefSchema: GenMessage<ContextItemRef> = /*@__PURE__*/
  messageDesc(file_context_context, 30);

/**
 * @generated from message lvdr.v2.context.ContextItemsOnNodeResponse
 */
export type ContextItemsOnNodeResponse = Message<"lvdr.v2.context.ContextItemsOnNodeResponse"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: repeated lvdr.v2.context.ContextItemRef items = 2;
   */
  items: ContextItemRef[];

  /**
   * MEM-12b: kinds whose source failed; their titles are "" (not known, never a blank title)
   *
   * @generated from field: repeated string unavailable_kinds = 3;
   */
  unavailableKinds: string[];
};

/**
 * Describes the message lvdr.v2.context.ContextItemsOnNodeResponse.
 * Use `create(ContextItemsOnNodeResponseSchema)` to create a new message.
 */
export const ContextItemsOnNodeResponseSchema: GenMessage<ContextItemsOnNodeResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 31);

/**
 * @generated from message lvdr.v2.context.ContextProposalsListRequest
 */
export type ContextProposalsListRequest = Message<"lvdr.v2.context.ContextProposalsListRequest"> & {
  /**
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: string graph = 2;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextProposalsListRequest.
 * Use `create(ContextProposalsListRequestSchema)` to create a new message.
 */
export const ContextProposalsListRequestSchema: GenMessage<ContextProposalsListRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 32);

/**
 * @generated from message lvdr.v2.context.ContextProposalsListResponse
 */
export type ContextProposalsListResponse = Message<"lvdr.v2.context.ContextProposalsListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.context.Proposal proposals = 1;
   */
  proposals: Proposal[];

  /**
   * @generated from field: int32 pending_count = 2;
   */
  pendingCount: number;
};

/**
 * Describes the message lvdr.v2.context.ContextProposalsListResponse.
 * Use `create(ContextProposalsListResponseSchema)` to create a new message.
 */
export const ContextProposalsListResponseSchema: GenMessage<ContextProposalsListResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 33);

/**
 * @generated from message lvdr.v2.context.ContextProposalsApplyRequest
 */
export type ContextProposalsApplyRequest = Message<"lvdr.v2.context.ContextProposalsApplyRequest"> & {
  /**
   * @generated from field: repeated string proposal_ids = 1;
   */
  proposalIds: string[];

  /**
   * @generated from field: string graph = 2;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextProposalsApplyRequest.
 * Use `create(ContextProposalsApplyRequestSchema)` to create a new message.
 */
export const ContextProposalsApplyRequestSchema: GenMessage<ContextProposalsApplyRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 34);

/**
 * @generated from message lvdr.v2.context.ContextProposalDismissRequest
 */
export type ContextProposalDismissRequest = Message<"lvdr.v2.context.ContextProposalDismissRequest"> & {
  /**
   * @generated from field: string proposal_id = 1;
   */
  proposalId: string;

  /**
   * @generated from field: string graph = 2;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextProposalDismissRequest.
 * Use `create(ContextProposalDismissRequestSchema)` to create a new message.
 */
export const ContextProposalDismissRequestSchema: GenMessage<ContextProposalDismissRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 35);

/**
 * MEM-10 (D21): set one item's trust floor, filed as a reviewable proposal.
 *
 * @generated from message lvdr.v2.context.ClassifyItemProposal
 */
export type ClassifyItemProposal = Message<"lvdr.v2.context.ClassifyItemProposal"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: string trust_floor = 3;
   */
  trustFloor: string;
};

/**
 * Describes the message lvdr.v2.context.ClassifyItemProposal.
 * Use `create(ClassifyItemProposalSchema)` to create a new message.
 */
export const ClassifyItemProposalSchema: GenMessage<ClassifyItemProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 36);

/**
 * MEM-10: run the deterministic signal pass. graph is "" or "personal"; a "ws:" graph is refused.
 *
 * @generated from message lvdr.v2.context.ContextSignalsRunRequest
 */
export type ContextSignalsRunRequest = Message<"lvdr.v2.context.ContextSignalsRunRequest"> & {
  /**
   * @generated from field: string graph = 1;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextSignalsRunRequest.
 * Use `create(ContextSignalsRunRequestSchema)` to create a new message.
 */
export const ContextSignalsRunRequestSchema: GenMessage<ContextSignalsRunRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 37);

/**
 * @generated from message lvdr.v2.context.ContextSignalsRunResponse
 */
export type ContextSignalsRunResponse = Message<"lvdr.v2.context.ContextSignalsRunResponse"> & {
  /**
   * @generated from field: int32 proposed = 1;
   */
  proposed: number;

  /**
   * @generated from field: int32 skipped = 2;
   */
  skipped: number;

  /**
   * @generated from field: repeated string unavailable = 3;
   */
  unavailable: string[];
};

/**
 * Describes the message lvdr.v2.context.ContextSignalsRunResponse.
 * Use `create(ContextSignalsRunResponseSchema)` to create a new message.
 */
export const ContextSignalsRunResponseSchema: GenMessage<ContextSignalsRunResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 38);

/**
 * @generated from message lvdr.v2.context.ContextProposalsApplyResponse
 */
export type ContextProposalsApplyResponse = Message<"lvdr.v2.context.ContextProposalsApplyResponse"> & {
  /**
   * @generated from field: repeated string applied_ids = 1;
   */
  appliedIds: string[];

  /**
   * @generated from field: string batch_id = 2;
   */
  batchId: string;

  /**
   * @generated from field: string failed_id = 3;
   */
  failedId: string;

  /**
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message lvdr.v2.context.ContextProposalsApplyResponse.
 * Use `create(ContextProposalsApplyResponseSchema)` to create a new message.
 */
export const ContextProposalsApplyResponseSchema: GenMessage<ContextProposalsApplyResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 39);

/**
 * @generated from message lvdr.v2.context.ContextHistoryListRequest
 */
export type ContextHistoryListRequest = Message<"lvdr.v2.context.ContextHistoryListRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * @generated from field: uint64 before_seq = 2;
   */
  beforeSeq: bigint;

  /**
   * @generated from field: string graph = 3;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextHistoryListRequest.
 * Use `create(ContextHistoryListRequestSchema)` to create a new message.
 */
export const ContextHistoryListRequestSchema: GenMessage<ContextHistoryListRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 40);

/**
 * @generated from message lvdr.v2.context.ContextHistoryListResponse
 */
export type ContextHistoryListResponse = Message<"lvdr.v2.context.ContextHistoryListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.context.HistoryEntry entries = 1;
   */
  entries: HistoryEntry[];
};

/**
 * Describes the message lvdr.v2.context.ContextHistoryListResponse.
 * Use `create(ContextHistoryListResponseSchema)` to create a new message.
 */
export const ContextHistoryListResponseSchema: GenMessage<ContextHistoryListResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 41);

/**
 * @generated from message lvdr.v2.context.ContextUndoRequest
 */
export type ContextUndoRequest = Message<"lvdr.v2.context.ContextUndoRequest"> & {
  /**
   * @generated from field: uint64 seq = 1;
   */
  seq: bigint;

  /**
   * @generated from field: string batch_id = 2;
   */
  batchId: string;

  /**
   * @generated from field: string graph = 3;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextUndoRequest.
 * Use `create(ContextUndoRequestSchema)` to create a new message.
 */
export const ContextUndoRequestSchema: GenMessage<ContextUndoRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 42);

/**
 * @generated from message lvdr.v2.context.ContextUndoResponse
 */
export type ContextUndoResponse = Message<"lvdr.v2.context.ContextUndoResponse"> & {
  /**
   * @generated from field: uint64 history_seq = 1;
   */
  historySeq: bigint;
};

/**
 * Describes the message lvdr.v2.context.ContextUndoResponse.
 * Use `create(ContextUndoResponseSchema)` to create a new message.
 */
export const ContextUndoResponseSchema: GenMessage<ContextUndoResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 43);

/**
 * @generated from message lvdr.v2.context.ContextLastUsedGetRequest
 */
export type ContextLastUsedGetRequest = Message<"lvdr.v2.context.ContextLastUsedGetRequest"> & {
  /**
   * @generated from field: string graph = 1;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextLastUsedGetRequest.
 * Use `create(ContextLastUsedGetRequestSchema)` to create a new message.
 */
export const ContextLastUsedGetRequestSchema: GenMessage<ContextLastUsedGetRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 44);

/**
 * @generated from message lvdr.v2.context.ContextLastUsedSetRequest
 */
export type ContextLastUsedSetRequest = Message<"lvdr.v2.context.ContextLastUsedSetRequest"> & {
  /**
   * @generated from field: string graph = 1;
   */
  graph: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.context.ContextLastUsedSetRequest.
 * Use `create(ContextLastUsedSetRequestSchema)` to create a new message.
 */
export const ContextLastUsedSetRequestSchema: GenMessage<ContextLastUsedSetRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 45);

/**
 * @generated from message lvdr.v2.context.ContextLastUsedResponse
 */
export type ContextLastUsedResponse = Message<"lvdr.v2.context.ContextLastUsedResponse"> & {
  /**
   * @generated from field: string graph = 1;
   */
  graph: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.context.ContextLastUsedResponse.
 * Use `create(ContextLastUsedResponseSchema)` to create a new message.
 */
export const ContextLastUsedResponseSchema: GenMessage<ContextLastUsedResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 46);

/**
 * --- MEM-09e item classification and processed record ---
 * The explicit per-item floor row (ctx:ic:).
 *
 * @generated from message lvdr.v2.context.ItemClassification
 */
export type ItemClassification = Message<"lvdr.v2.context.ItemClassification"> & {
  /**
   * @generated from field: string trust_floor = 1;
   */
  trustFloor: string;

  /**
   * @generated from field: string actor = 2;
   */
  actor: string;

  /**
   * @generated from field: int64 set_at_ms = 3;
   */
  setAtMs: bigint;
};

/**
 * Describes the message lvdr.v2.context.ItemClassification.
 * Use `create(ItemClassificationSchema)` to create a new message.
 */
export const ItemClassificationSchema: GenMessage<ItemClassification> = /*@__PURE__*/
  messageDesc(file_context_context, 47);

/**
 * Where an item was processed (ctx:pr:); unix seconds, 0 = never.
 *
 * @generated from message lvdr.v2.context.ProcessedRecord
 */
export type ProcessedRecord = Message<"lvdr.v2.context.ProcessedRecord"> & {
  /**
   * @generated from field: int64 standard_first_at = 1;
   */
  standardFirstAt: bigint;

  /**
   * @generated from field: int64 standard_last_at = 2;
   */
  standardLastAt: bigint;

  /**
   * @generated from field: int64 confidential_last_at = 3;
   */
  confidentialLastAt: bigint;
};

/**
 * Describes the message lvdr.v2.context.ProcessedRecord.
 * Use `create(ProcessedRecordSchema)` to create a new message.
 */
export const ProcessedRecordSchema: GenMessage<ProcessedRecord> = /*@__PURE__*/
  messageDesc(file_context_context, 48);

/**
 * @generated from message lvdr.v2.context.ContextItemClassificationGetRequest
 */
export type ContextItemClassificationGetRequest = Message<"lvdr.v2.context.ContextItemClassificationGetRequest"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;
};

/**
 * Describes the message lvdr.v2.context.ContextItemClassificationGetRequest.
 * Use `create(ContextItemClassificationGetRequestSchema)` to create a new message.
 */
export const ContextItemClassificationGetRequestSchema: GenMessage<ContextItemClassificationGetRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 49);

/**
 * @generated from message lvdr.v2.context.ContextItemClassificationSetRequest
 */
export type ContextItemClassificationSetRequest = Message<"lvdr.v2.context.ContextItemClassificationSetRequest"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: string trust_floor = 3;
   */
  trustFloor: string;

  /**
   * @generated from field: bool confirm = 4;
   */
  confirm: boolean;
};

/**
 * Describes the message lvdr.v2.context.ContextItemClassificationSetRequest.
 * Use `create(ContextItemClassificationSetRequestSchema)` to create a new message.
 */
export const ContextItemClassificationSetRequestSchema: GenMessage<ContextItemClassificationSetRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 50);

/**
 * @generated from message lvdr.v2.context.ContextItemClassificationResponse
 */
export type ContextItemClassificationResponse = Message<"lvdr.v2.context.ContextItemClassificationResponse"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: string trust_floor = 3;
   */
  trustFloor: string;

  /**
   * @generated from field: bool explicit = 4;
   */
  explicit: boolean;

  /**
   * @generated from field: uint64 history_seq = 5;
   */
  historySeq: bigint;
};

/**
 * Describes the message lvdr.v2.context.ContextItemClassificationResponse.
 * Use `create(ContextItemClassificationResponseSchema)` to create a new message.
 */
export const ContextItemClassificationResponseSchema: GenMessage<ContextItemClassificationResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 51);

/**
 * --- MEM-12 the Contexts space (backend) ---
 * Compound kind payloads: each is the New message of one proposal kind.
 *
 * @generated from message lvdr.v2.context.MergeNodesProposal
 */
export type MergeNodesProposal = Message<"lvdr.v2.context.MergeNodesProposal"> & {
  /**
   * @generated from field: string source_id = 1;
   */
  sourceId: string;

  /**
   * @generated from field: string target_id = 2;
   */
  targetId: string;
};

/**
 * Describes the message lvdr.v2.context.MergeNodesProposal.
 * Use `create(MergeNodesProposalSchema)` to create a new message.
 */
export const MergeNodesProposalSchema: GenMessage<MergeNodesProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 52);

/**
 * @generated from message lvdr.v2.context.SplitNodeProposal
 */
export type SplitNodeProposal = Message<"lvdr.v2.context.SplitNodeProposal"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string new_name = 2;
   */
  newName: string;

  /**
   * @generated from field: repeated lvdr.v2.context.ContextItemRef items = 3;
   */
  items: ContextItemRef[];

  /**
   * @generated from field: repeated string child_ids = 4;
   */
  childIds: string[];

  /**
   * @generated from field: repeated string fact_ids = 5;
   */
  factIds: string[];
};

/**
 * Describes the message lvdr.v2.context.SplitNodeProposal.
 * Use `create(SplitNodeProposalSchema)` to create a new message.
 */
export const SplitNodeProposalSchema: GenMessage<SplitNodeProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 53);

/**
 * @generated from message lvdr.v2.context.NodeToEntityProposal
 */
export type NodeToEntityProposal = Message<"lvdr.v2.context.NodeToEntityProposal"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string into_node_id = 2;
   */
  intoNodeId: string;
};

/**
 * Describes the message lvdr.v2.context.NodeToEntityProposal.
 * Use `create(NodeToEntityProposalSchema)` to create a new message.
 */
export const NodeToEntityProposalSchema: GenMessage<NodeToEntityProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 54);

/**
 * @generated from message lvdr.v2.context.EntityToNodeProposal
 */
export type EntityToNodeProposal = Message<"lvdr.v2.context.EntityToNodeProposal"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string parent_id = 2;
   */
  parentId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message lvdr.v2.context.EntityToNodeProposal.
 * Use `create(EntityToNodeProposalSchema)` to create a new message.
 */
export const EntityToNodeProposalSchema: GenMessage<EntityToNodeProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 55);

/**
 * @generated from message lvdr.v2.context.BulkLinksProposal
 */
export type BulkLinksProposal = Message<"lvdr.v2.context.BulkLinksProposal"> & {
  /**
   * @generated from field: repeated lvdr.v2.context.ContextItemRef items = 1;
   */
  items: ContextItemRef[];

  /**
   * @generated from field: repeated string add_node_ids = 2;
   */
  addNodeIds: string[];

  /**
   * @generated from field: repeated string remove_node_ids = 3;
   */
  removeNodeIds: string[];
};

/**
 * Describes the message lvdr.v2.context.BulkLinksProposal.
 * Use `create(BulkLinksProposalSchema)` to create a new message.
 */
export const BulkLinksProposalSchema: GenMessage<BulkLinksProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 56);

/**
 * @generated from message lvdr.v2.context.FactEditProposal
 */
export type FactEditProposal = Message<"lvdr.v2.context.FactEditProposal"> & {
  /**
   * @generated from field: string fact_id = 1;
   */
  factId: string;

  /**
   * @generated from field: optional string text = 2;
   */
  text?: string | undefined;

  /**
   * @generated from field: optional string stamp = 3;
   */
  stamp?: string | undefined;
};

/**
 * Describes the message lvdr.v2.context.FactEditProposal.
 * Use `create(FactEditProposalSchema)` to create a new message.
 */
export const FactEditProposalSchema: GenMessage<FactEditProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 57);

/**
 * @generated from message lvdr.v2.context.FactDeleteProposal
 */
export type FactDeleteProposal = Message<"lvdr.v2.context.FactDeleteProposal"> & {
  /**
   * @generated from field: string fact_id = 1;
   */
  factId: string;
};

/**
 * Describes the message lvdr.v2.context.FactDeleteProposal.
 * Use `create(FactDeleteProposalSchema)` to create a new message.
 */
export const FactDeleteProposalSchema: GenMessage<FactDeleteProposal> = /*@__PURE__*/
  messageDesc(file_context_context, 58);

/**
 * One direct edit: Graph.Operate applies exactly one kind payload now.
 *
 * @generated from message lvdr.v2.context.ContextOperateRequest
 */
export type ContextOperateRequest = Message<"lvdr.v2.context.ContextOperateRequest"> & {
  /**
   * @generated from oneof lvdr.v2.context.ContextOperateRequest.op
   */
  op: {
    /**
     * @generated from field: lvdr.v2.context.MergeNodesProposal merge_nodes = 1;
     */
    value: MergeNodesProposal;
    case: "mergeNodes";
  } | {
    /**
     * @generated from field: lvdr.v2.context.SplitNodeProposal split_node = 2;
     */
    value: SplitNodeProposal;
    case: "splitNode";
  } | {
    /**
     * @generated from field: lvdr.v2.context.NodeToEntityProposal node_to_entity = 3;
     */
    value: NodeToEntityProposal;
    case: "nodeToEntity";
  } | {
    /**
     * @generated from field: lvdr.v2.context.EntityToNodeProposal entity_to_node = 4;
     */
    value: EntityToNodeProposal;
    case: "entityToNode";
  } | {
    /**
     * @generated from field: lvdr.v2.context.BulkLinksProposal bulk_links = 5;
     */
    value: BulkLinksProposal;
    case: "bulkLinks";
  } | {
    /**
     * @generated from field: lvdr.v2.context.FactEditProposal fact_edit = 6;
     */
    value: FactEditProposal;
    case: "factEdit";
  } | {
    /**
     * @generated from field: lvdr.v2.context.FactDeleteProposal fact_delete = 7;
     */
    value: FactDeleteProposal;
    case: "factDelete";
  } | { case: undefined; value?: undefined };

  /**
   * MEM-09e: accepts the raise preview a refused Operate returned
   *
   * @generated from field: bool confirm_raise = 8;
   */
  confirmRaise: boolean;

  /**
   * MEM-09g: "" = personal, "ws:<id>" = a Workspace graph
   *
   * @generated from field: string graph = 9;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextOperateRequest.
 * Use `create(ContextOperateRequestSchema)` to create a new message.
 */
export const ContextOperateRequestSchema: GenMessage<ContextOperateRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 59);

/**
 * An Operate refused for an unconfirmed floor raise carries raise_preview and no batch_id: the
 * client shows the D20 warning and re-sends with confirm_raise.
 *
 * @generated from message lvdr.v2.context.ContextOperateResponse
 */
export type ContextOperateResponse = Message<"lvdr.v2.context.ContextOperateResponse"> & {
  /**
   * @generated from field: string batch_id = 1;
   */
  batchId: string;

  /**
   * @generated from field: string proposal_id = 2;
   */
  proposalId: string;

  /**
   * @generated from field: string preview = 3;
   */
  preview: string;

  /**
   * @generated from field: lvdr.v2.context.ContextRaisePreview raise_preview = 4;
   */
  raisePreview?: ContextRaisePreview | undefined;
};

/**
 * Describes the message lvdr.v2.context.ContextOperateResponse.
 * Use `create(ContextOperateResponseSchema)` to create a new message.
 */
export const ContextOperateResponseSchema: GenMessage<ContextOperateResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 60);

/**
 * @generated from message lvdr.v2.context.InspectedNode
 */
export type InspectedNode = Message<"lvdr.v2.context.InspectedNode"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string verdict = 2;
   */
  verdict: string;
};

/**
 * Describes the message lvdr.v2.context.InspectedNode.
 * Use `create(InspectedNodeSchema)` to create a new message.
 */
export const InspectedNodeSchema: GenMessage<InspectedNode> = /*@__PURE__*/
  messageDesc(file_context_context, 61);

/**
 * @generated from message lvdr.v2.context.InspectedSession
 */
export type InspectedSession = Message<"lvdr.v2.context.InspectedSession"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string node_id = 3;
   */
  nodeId: string;

  /**
   * @generated from field: string verdict = 4;
   */
  verdict: string;
};

/**
 * Describes the message lvdr.v2.context.InspectedSession.
 * Use `create(InspectedSessionSchema)` to create a new message.
 */
export const InspectedSessionSchema: GenMessage<InspectedSession> = /*@__PURE__*/
  messageDesc(file_context_context, 62);

/**
 * @generated from message lvdr.v2.context.InspectedToken
 */
export type InspectedToken = Message<"lvdr.v2.context.InspectedToken"> & {
  /**
   * @generated from field: string token_id = 1;
   */
  tokenId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string node_id = 3;
   */
  nodeId: string;

  /**
   * @generated from field: string verdict = 4;
   */
  verdict: string;
};

/**
 * Describes the message lvdr.v2.context.InspectedToken.
 * Use `create(InspectedTokenSchema)` to create a new message.
 */
export const InspectedTokenSchema: GenMessage<InspectedToken> = /*@__PURE__*/
  messageDesc(file_context_context, 63);

/**
 * @generated from message lvdr.v2.context.PropertyOrigin
 */
export type PropertyOrigin = Message<"lvdr.v2.context.PropertyOrigin"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: string from_node_id = 3;
   */
  fromNodeId: string;

  /**
   * @generated from field: string layer = 4;
   */
  layer: string;
};

/**
 * Describes the message lvdr.v2.context.PropertyOrigin.
 * Use `create(PropertyOriginSchema)` to create a new message.
 */
export const PropertyOriginSchema: GenMessage<PropertyOrigin> = /*@__PURE__*/
  messageDesc(file_context_context, 64);

/**
 * @generated from message lvdr.v2.context.KindCount
 */
export type KindCount = Message<"lvdr.v2.context.KindCount"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message lvdr.v2.context.KindCount.
 * Use `create(KindCountSchema)` to create a new message.
 */
export const KindCountSchema: GenMessage<KindCount> = /*@__PURE__*/
  messageDesc(file_context_context, 65);

/**
 * @generated from message lvdr.v2.context.ContextInspectRequest
 */
export type ContextInspectRequest = Message<"lvdr.v2.context.ContextInspectRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string graph = 2;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextInspectRequest.
 * Use `create(ContextInspectRequestSchema)` to create a new message.
 */
export const ContextInspectRequestSchema: GenMessage<ContextInspectRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 66);

/**
 * @generated from message lvdr.v2.context.ContextInspection
 */
export type ContextInspection = Message<"lvdr.v2.context.ContextInspection"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: repeated lvdr.v2.context.InspectedNode sees = 2;
   */
  sees: InspectedNode[];

  /**
   * @generated from field: repeated lvdr.v2.context.InspectedNode seen_by_nodes = 3;
   */
  seenByNodes: InspectedNode[];

  /**
   * @generated from field: repeated lvdr.v2.context.InspectedSession seen_by_sessions = 4;
   */
  seenBySessions: InspectedSession[];

  /**
   * sessions on the root (Everything), counted not listed
   *
   * @generated from field: int32 root_session_count = 5;
   */
  rootSessionCount: number;

  /**
   * "ok" | "not_available"
   *
   * @generated from field: string sessions_status = 6;
   */
  sessionsStatus: string;

  /**
   * @generated from field: repeated lvdr.v2.context.InspectedToken seen_by_tokens = 7;
   */
  seenByTokens: InspectedToken[];

  /**
   * "ok" | "not_available" (MEM-09f)
   *
   * @generated from field: string tokens_status = 8;
   */
  tokensStatus: string;

  /**
   * @generated from field: repeated lvdr.v2.context.PropertyOrigin origins = 9;
   */
  origins: PropertyOrigin[];

  /**
   * includes item_kind "fact" when facts_status is "ok"
   *
   * @generated from field: repeated lvdr.v2.context.KindCount direct_counts = 10;
   */
  directCounts: KindCount[];

  /**
   * @generated from field: repeated lvdr.v2.context.KindCount subtree_counts = 11;
   */
  subtreeCounts: KindCount[];

  /**
   * @generated from field: int64 processed_standard = 12;
   */
  processedStandard: bigint;

  /**
   * "ok"; a failed count fails the request (D27: never a zero)
   *
   * @generated from field: string processed_status = 13;
   */
  processedStatus: string;

  /**
   * "ok" | "not_available" (no NodeFacts: never a zero)
   *
   * @generated from field: string facts_status = 14;
   */
  factsStatus: string;

  /**
   * linked items with no processing record: not known, not "not processed"
   *
   * @generated from field: int64 processed_unknown = 15;
   */
  processedUnknown: bigint;
};

/**
 * Describes the message lvdr.v2.context.ContextInspection.
 * Use `create(ContextInspectionSchema)` to create a new message.
 */
export const ContextInspectionSchema: GenMessage<ContextInspection> = /*@__PURE__*/
  messageDesc(file_context_context, 67);

/**
 * @generated from message lvdr.v2.context.ContextPreviewPropertiesRequest
 */
export type ContextPreviewPropertiesRequest = Message<"lvdr.v2.context.ContextPreviewPropertiesRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: lvdr.v2.context.NodeProperties properties = 2;
   */
  properties?: NodeProperties | undefined;

  /**
   * @generated from field: string graph = 3;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextPreviewPropertiesRequest.
 * Use `create(ContextPreviewPropertiesRequestSchema)` to create a new message.
 */
export const ContextPreviewPropertiesRequestSchema: GenMessage<ContextPreviewPropertiesRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 68);

/**
 * @generated from message lvdr.v2.context.ContextImpactPreview
 */
export type ContextImpactPreview = Message<"lvdr.v2.context.ContextImpactPreview"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: repeated string changed_node_ids = 2;
   */
  changedNodeIds: string[];

  /**
   * @generated from field: int32 item_count = 3;
   */
  itemCount: number;

  /**
   * @generated from field: repeated lvdr.v2.context.KindCount items_by_kind = 4;
   */
  itemsByKind: KindCount[];

  /**
   * @generated from field: int64 processed_standard = 5;
   */
  processedStandard: bigint;

  /**
   * @generated from field: int64 processed_unknown = 6;
   */
  processedUnknown: bigint;

  /**
   * @generated from field: string processed_status = 7;
   */
  processedStatus: string;

  /**
   * "ok" | "not_available"
   *
   * @generated from field: string facts_status = 8;
   */
  factsStatus: string;
};

/**
 * Describes the message lvdr.v2.context.ContextImpactPreview.
 * Use `create(ContextImpactPreviewSchema)` to create a new message.
 */
export const ContextImpactPreviewSchema: GenMessage<ContextImpactPreview> = /*@__PURE__*/
  messageDesc(file_context_context, 69);

/**
 * @generated from message lvdr.v2.context.UnsortedEntry
 */
export type UnsortedEntry = Message<"lvdr.v2.context.UnsortedEntry"> & {
  /**
   * @generated from field: string item_kind = 1;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: int64 updated_at_ms = 4;
   */
  updatedAtMs: bigint;

  /**
   * @generated from field: int32 item_count = 5;
   */
  itemCount: number;
};

/**
 * Describes the message lvdr.v2.context.UnsortedEntry.
 * Use `create(UnsortedEntrySchema)` to create a new message.
 */
export const UnsortedEntrySchema: GenMessage<UnsortedEntry> = /*@__PURE__*/
  messageDesc(file_context_context, 70);

/**
 * @generated from message lvdr.v2.context.ContextUnsortedListRequest
 */
export type ContextUnsortedListRequest = Message<"lvdr.v2.context.ContextUnsortedListRequest"> & {
  /**
   * @generated from field: string cursor = 1;
   */
  cursor: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string graph = 4;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextUnsortedListRequest.
 * Use `create(ContextUnsortedListRequestSchema)` to create a new message.
 */
export const ContextUnsortedListRequestSchema: GenMessage<ContextUnsortedListRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 71);

/**
 * @generated from message lvdr.v2.context.ContextUnsortedListResponse
 */
export type ContextUnsortedListResponse = Message<"lvdr.v2.context.ContextUnsortedListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.context.UnsortedEntry items = 1;
   */
  items: UnsortedEntry[];

  /**
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;

  /**
   * @generated from field: map<string, int32> count_by_kind = 3;
   */
  countByKind: { [key: string]: number };

  /**
   * sources that failed this request; their items are not listed
   *
   * @generated from field: repeated string unavailable_kinds = 4;
   */
  unavailableKinds: string[];
};

/**
 * Describes the message lvdr.v2.context.ContextUnsortedListResponse.
 * Use `create(ContextUnsortedListResponseSchema)` to create a new message.
 */
export const ContextUnsortedListResponseSchema: GenMessage<ContextUnsortedListResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 72);

/**
 * @generated from message lvdr.v2.context.ContextEraseExportRequest
 */
export type ContextEraseExportRequest = Message<"lvdr.v2.context.ContextEraseExportRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.context.ContextEraseExportRequest.
 * Use `create(ContextEraseExportRequestSchema)` to create a new message.
 */
export const ContextEraseExportRequestSchema: GenMessage<ContextEraseExportRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 73);

/**
 * @generated from message lvdr.v2.context.ContextEraseExportResponse
 */
export type ContextEraseExportResponse = Message<"lvdr.v2.context.ContextEraseExportResponse"> & {
  /**
   * @generated from field: bytes bundle = 1;
   */
  bundle: Uint8Array;

  /**
   * @generated from field: string sha256 = 2;
   */
  sha256: string;
};

/**
 * Describes the message lvdr.v2.context.ContextEraseExportResponse.
 * Use `create(ContextEraseExportResponseSchema)` to create a new message.
 */
export const ContextEraseExportResponseSchema: GenMessage<ContextEraseExportResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 74);

/**
 * @generated from message lvdr.v2.context.ContextEraseRequest
 */
export type ContextEraseRequest = Message<"lvdr.v2.context.ContextEraseRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string sha256 = 2;
   */
  sha256: string;
};

/**
 * Describes the message lvdr.v2.context.ContextEraseRequest.
 * Use `create(ContextEraseRequestSchema)` to create a new message.
 */
export const ContextEraseRequestSchema: GenMessage<ContextEraseRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 75);

/**
 * @generated from message lvdr.v2.context.ContextEraseResponse
 */
export type ContextEraseResponse = Message<"lvdr.v2.context.ContextEraseResponse"> & {
};

/**
 * Describes the message lvdr.v2.context.ContextEraseResponse.
 * Use `create(ContextEraseResponseSchema)` to create a new message.
 */
export const ContextEraseResponseSchema: GenMessage<ContextEraseResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 76);

/**
 * @generated from message lvdr.v2.context.ContextFact
 */
export type ContextFact = Message<"lvdr.v2.context.ContextFact"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: bool user_edited = 4;
   */
  userEdited: boolean;

  /**
   * @generated from field: int64 updated_at_ms = 5;
   */
  updatedAtMs: bigint;

  /**
   * @generated from field: string session_id = 6;
   */
  sessionId: string;

  /**
   * @generated from field: string speaker_user_id = 7;
   */
  speakerUserId: string;

  /**
   * @generated from field: string speaker_name = 8;
   */
  speakerName: string;
};

/**
 * Describes the message lvdr.v2.context.ContextFact.
 * Use `create(ContextFactSchema)` to create a new message.
 */
export const ContextFactSchema: GenMessage<ContextFact> = /*@__PURE__*/
  messageDesc(file_context_context, 77);

/**
 * @generated from message lvdr.v2.context.ContextFactsOnNodeRequest
 */
export type ContextFactsOnNodeRequest = Message<"lvdr.v2.context.ContextFactsOnNodeRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string cursor = 2;
   */
  cursor: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string graph = 4;
   */
  graph: string;
};

/**
 * Describes the message lvdr.v2.context.ContextFactsOnNodeRequest.
 * Use `create(ContextFactsOnNodeRequestSchema)` to create a new message.
 */
export const ContextFactsOnNodeRequestSchema: GenMessage<ContextFactsOnNodeRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 78);

/**
 * @generated from message lvdr.v2.context.ContextFactsOnNodeResponse
 */
export type ContextFactsOnNodeResponse = Message<"lvdr.v2.context.ContextFactsOnNodeResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.context.ContextFact facts = 1;
   */
  facts: ContextFact[];

  /**
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;
};

/**
 * Describes the message lvdr.v2.context.ContextFactsOnNodeResponse.
 * Use `create(ContextFactsOnNodeResponseSchema)` to create a new message.
 */
export const ContextFactsOnNodeResponseSchema: GenMessage<ContextFactsOnNodeResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 79);

/**
 * Pushed to the user's connections when the pending proposal set may have changed. It
 * carries no count (needsyou.Realtime's rule): the client refetches ContextProposalsList.
 *
 * @generated from message lvdr.v2.context.ContextProposalsChangedEvent
 */
export type ContextProposalsChangedEvent = Message<"lvdr.v2.context.ContextProposalsChangedEvent"> & {
};

/**
 * Describes the message lvdr.v2.context.ContextProposalsChangedEvent.
 * Use `create(ContextProposalsChangedEventSchema)` to create a new message.
 */
export const ContextProposalsChangedEventSchema: GenMessage<ContextProposalsChangedEvent> = /*@__PURE__*/
  messageDesc(file_context_context, 80);

/**
 * --- MEM-09g Workspace personality ("Me in this Workspace") ---
 * Owner-only: stored in the requesting user's settings.db (ctx:pers:<workspace_id>),
 * never in the shared island. trust_floor is refused.
 *
 * @generated from message lvdr.v2.context.ContextPersonalityGetRequest
 */
export type ContextPersonalityGetRequest = Message<"lvdr.v2.context.ContextPersonalityGetRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.context.ContextPersonalityGetRequest.
 * Use `create(ContextPersonalityGetRequestSchema)` to create a new message.
 */
export const ContextPersonalityGetRequestSchema: GenMessage<ContextPersonalityGetRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 81);

/**
 * @generated from message lvdr.v2.context.ContextPersonalitySetRequest
 */
export type ContextPersonalitySetRequest = Message<"lvdr.v2.context.ContextPersonalitySetRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: lvdr.v2.context.NodeProperties properties = 2;
   */
  properties?: NodeProperties | undefined;
};

/**
 * Describes the message lvdr.v2.context.ContextPersonalitySetRequest.
 * Use `create(ContextPersonalitySetRequestSchema)` to create a new message.
 */
export const ContextPersonalitySetRequestSchema: GenMessage<ContextPersonalitySetRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 82);

/**
 * --- MEM-09n: file a transfer unit (one wsitem: manifest) on Workspace nodes ---
 * Applies next = (cur ∪ add) \ remove to every node id of the unit, under one batch id
 * (ContextUndoRequest{batch_id} undoes it). batch_id "" ⇒ nothing changed.
 *
 * @generated from message lvdr.v2.context.ContextUnitLinksSetRequest
 */
export type ContextUnitLinksSetRequest = Message<"lvdr.v2.context.ContextUnitLinksSetRequest"> & {
  /**
   * @generated from field: string graph = 1;
   */
  graph: string;

  /**
   * @generated from field: string transfer_id = 2;
   */
  transferId: string;

  /**
   * @generated from field: repeated string add_node_ids = 3;
   */
  addNodeIds: string[];

  /**
   * @generated from field: repeated string remove_node_ids = 4;
   */
  removeNodeIds: string[];
};

/**
 * Describes the message lvdr.v2.context.ContextUnitLinksSetRequest.
 * Use `create(ContextUnitLinksSetRequestSchema)` to create a new message.
 */
export const ContextUnitLinksSetRequestSchema: GenMessage<ContextUnitLinksSetRequest> = /*@__PURE__*/
  messageDesc(file_context_context, 83);

/**
 * @generated from message lvdr.v2.context.ContextUnitLinksSetResponse
 */
export type ContextUnitLinksSetResponse = Message<"lvdr.v2.context.ContextUnitLinksSetResponse"> & {
  /**
   * @generated from field: string batch_id = 1;
   */
  batchId: string;

  /**
   * @generated from field: int32 item_count = 2;
   */
  itemCount: number;
};

/**
 * Describes the message lvdr.v2.context.ContextUnitLinksSetResponse.
 * Use `create(ContextUnitLinksSetResponseSchema)` to create a new message.
 */
export const ContextUnitLinksSetResponseSchema: GenMessage<ContextUnitLinksSetResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 84);

/**
 * @generated from message lvdr.v2.context.ContextPersonalityResponse
 */
export type ContextPersonalityResponse = Message<"lvdr.v2.context.ContextPersonalityResponse"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: lvdr.v2.context.NodeProperties properties = 2;
   */
  properties?: NodeProperties | undefined;

  /**
   * @generated from field: uint32 max_preference_runes = 3;
   */
  maxPreferenceRunes: number;
};

/**
 * Describes the message lvdr.v2.context.ContextPersonalityResponse.
 * Use `create(ContextPersonalityResponseSchema)` to create a new message.
 */
export const ContextPersonalityResponseSchema: GenMessage<ContextPersonalityResponse> = /*@__PURE__*/
  messageDesc(file_context_context, 85);

